"use client"
import React, { useState, useEffect, useRef } from "react";
import EmbeddedNavbar from "@/components/maps/embed/EmbeddedNavbar";
import ParentContentThumbnail from "@/components/shared/ParentContentThumbnail";
import { useRouter, useSearchParams } from "next/navigation";

import useApi from "@/components/api/useApi";
import { useConfig } from "@/lib/providers/ConfigProvider";

import "@/components/maps/embed/EmbeddedStoryMapWidget.css";
import MapAndPins from "@/components/maps/MapAndPins";
import { useTenant } from "@/lib/providers/TenantProvider";

const EmbeddedStoryMapWidget = props => {
  const { profile, community } = useTenant();
  const router = useRouter();
  const { webUrl } = useConfig();
  const [loaded, setLoaded] = useState(false);
  const [denied, setDenied] = useState(false);
  const [map, setMap] = useState(null);
  const [points, setPoints] = useState([]);
  const [title, setTitle] = useState(null);
  const [subtitle, setSubtitle] = useState(null);
  const [headerLogoId, setHeaderLogoId] = useState(null);
  const [thumbnailContent, setThumbnailContent] = useState(null);
  const [variant, setVariant] = useState("light");
  const api = useApi();
  let unfilteredPoints = useRef([]);

  const searchParams = useSearchParams();
    const key = searchParams.get("key");
    const variantParam = searchParams.get("variant");
    const mapId = props.match.params.mapId;

  const fetchMap = (profile, mapId, keyParam, variantValue) => {
    const profileName = profile.resourceName;
    if (keyParam) {
      if (variantValue && (variantValue === "light" || variantValue === "dark")) {
        setVariant(variantValue);
      }

      api
        .getProfileMapWithToken(profileName, mapId, keyParam, "Client")
        .then(map => {
          setTitle(map.title);
          setSubtitle(map.owner.displayName);
          setHeaderLogoId(map.owner.logoId);
          setThumbnailContent(
            <ParentContentThumbnail
              imageId={map.coverPhotoId}
              owner={map.owner}
              title={map.title}
              description={map.text}
              url={webUrl + profileName + "/stories/" + map.id}
              contributionUrl={
                map.allowPublicContributors
                  ? webUrl +
                    profileName +
                    "/stories/" +
                    map.id +
                    "?contribute=pin"
                  : null
              }
            />
          );
          setMap(map);
          return api.getProfileMapPointsWithToken(
            profileName,
            mapId,
            keyParam,
            "Client"
          );
        })
        .then(points => {
          setPoints(points);
          unfilteredPoints.current = points;
          setLoaded(true);
        })
        .catch(error => {
          setLoaded(true);
          setDenied(true);
        });
    } else {
      setLoaded(true);
      setDenied(true);
    }
  };

  useEffect(() => {
    if( key && mapId && profile && !loaded ) {
      fetchMap(profile, mapId, key, variantParam);
    }
  }, [key, profile, mapId, loaded]);

  useEffect(() => {
    if (denied) router.replace("/403");
  }, [denied, router]);

  if (!loaded) {
    return <></>;
  } else if (denied) {
    return null;
  } else {
    return (
      <div className="embedded-map-widget d-flex flex-column px-0 vh-100">
        <EmbeddedNavbar
          title={title}
          description={subtitle}
          logoId={headerLogoId}
          variant={variant ?? "light"}
        />
        <MapAndPins
          name={props.match.params.name}
          mapView={map}
          points={points}
          fullscreenEnabled={false}
          fullscreenMode={true}
          interactable={true}
          external={true}
          welcomeMessage={true}
          storyModeEnabled={false}
        />
      </div>
    );
  }
};

export default EmbeddedStoryMapWidget;
